import { FONT_BRIGHTNESS } from './constants';
export const defaultThemeVariables = {
    appHeaderBackgroundColor: 'white',
    appHeaderFontBrightness: FONT_BRIGHTNESS.DARK,
    buttonBorderRadius: 5,
    fontBrightness: FONT_BRIGHTNESS.DARK,
    frameBackgroundColor: 'white',
    frameDropShadow: 'rgba(0, 0, 0, 0.1)',
    frameFontBrightness: FONT_BRIGHTNESS.DARK,
    globalBorderRadius: 10,
    inputBackgroundColor: 'white',
    inputFontBrightness: FONT_BRIGHTNESS.DARK,
    inputOutlineColor: 'black',
    secondaryButtonBackgroundColor: 'cloud',
    secondaryButtonFontBrightness: FONT_BRIGHTNESS.DARK,
    groupHeaderBackgroundColor: 'white',
    groupHeaderFontBrightness: FONT_BRIGHTNESS.DARK,
    outboxedFontBrightness: FONT_BRIGHTNESS.DARK,
    secondaryNavigationBackgroundColor: 'white',
    secondaryNavigationFontBrightness: FONT_BRIGHTNESS.DARK,
    headerSeparatorDisplay: true,
};
//# sourceMappingURL=defaultThemeVariables.js.map